import React from "react";
import { Helmet } from "react-helmet";

const blankPage : React.FC = () => {
  return (
    <div className="body">
       <Helmet>
        <title>{process.env.REACT_APP_TITLE}</title>
      </Helmet>
    </div>
  );
}

export default blankPage;